'use strict';

import * as Onyx from '../lib/onyx.min.js';
import { default as MatterJSEntity } from './base-matter.js';

const SCALE = 0.35;
const STIFFNESS = 0.010;//0.75;
const DOT_DISTANCE = 32;

export default class Slingshot extends MatterJSEntity {
    constructor(position = [0,0], scale, rotation, { matterEngine = null} = {}){
        super(matterEngine, position);

        this.launched = false;
        this.waitForSleep = false; // Wait for sleep before moving on to next round

        // Used for pulling the camera back when pulling the player back
        this.stretch = 0;

        Onyx.ImportModelFromOBJ.load({src: "res/models/targetRing.obj"}).then((model) => {
            this.addComponent(model);

            // model.meshes[0].material.ambientTexture = this.parentScene.caustic;
            model.meshes[0].material.lighting = 0;
            model.meshes[0].material.buildProgram();

            model.transform.rotateY(-1);
            model.transform.scaleTo(SCALE, SCALE, SCALE);
        });

        this.dots = [];
        for(var i = 0; i < 12; i++){
            this.dots[i] = new Onyx.Sprite({src: `res/textures/dot-${i}.png`, pivot: [0.5, 0.5], pixelsPerUnit: 0.3});
            this.dots[i].transform.translateX(-i * DOT_DISTANCE);
            this.dots[i].visible = false;
            this.addComponent(this.dots[i]);
        }
    }

    update(...args){
        super.update(...args);

        this.visible = !this.launched;

        if(!this.launched && this.parentScene.player && this.parentScene.player.physicsEnabled){
            var angle = Math.atan2(this.transform.y - this.parentScene.player.transform.y, this.transform.x - this.parentScene.player.transform.x);

            var distance = Math.hypot(this.transform.x - this.parentScene.player.transform.x, this.transform.y - this.parentScene.player.transform.y);
            var dotCount = Math.floor(distance / DOT_DISTANCE);

            this.stretch = distance;

            if(distance > DOT_DISTANCE){
                this.transform.rotateToZ(angle);

                // console.log(angle);
                if(angle > Math.PI / 2) angle -= Math.PI;
                if(angle < -Math.PI / 2) angle += Math.PI;

                this.parentScene.player.body.angle = -angle;
            }else{
                this.transform.rotateToZ(0);
                // this.parentScene.player.body.angle = Math.PI / 2;

                if(Math.abs(this.parentScene.player.body.angle) > 0.1){
                    this.parentScene.player.body.torque = ((this.parentScene.player.body.angle < 0)?1:-1) * 0.05;
                }
            }

            for(var i = 0; i < this.dots.length; i++){
                this.dots[i].visible = i < dotCount;
            }
        }else{
            this.transform.rotateToZ(0);

            for(var i = 0; i < this.dots.length; i++){
                this.dots[i].visible = false;
            }
        }
        
    }

    launch(){
        if(this.elastic && this.parentScene.player.transform.x < this.transform.x){//} && this.parentScene.player.transform.y < this.transform.y){
            this.launched = true;

            // Remove clickable
            this.parentScene.player.emit("launched");
            
            // Break elastic
            this.parentScene.setTimeout(() => {
                Matter.World.remove(this.matterEngine.world, [this.elastic]);
                this.parentScene.emit("launched");
            }, 32);
        }
    }

    attachAmmo(ammoBody){
        this.launched = false;

        // Slingshot elastic
        this.elastic = Matter.Constraint.create({ 
            pointA: { x: this.transform.x, y: -this.transform.y }, 
            bodyB: ammoBody, 
            stiffness: STIFFNESS
        });

        Matter.World.add(this.matterEngine.world, [this.elastic]);
    }
}